module.exports = __webpack_public_path__ + "img/WEBSITE10.1d79004b.webp";